module.exports = __webpack_public_path__ + "846d1890aee87fde5d8ced8eba360c3a.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-700italic.woff
// module id = 674
// module chunks = 0